import { AmbientOcclusionFeature } from '@kb3d/models/classes';
import { Token } from '@kb3d/models/classes/token';
import { ITrackedClass } from '@kb3d/models/interfaces/tracked-class';
import { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';
import { FeatureRenderer } from './feature';
import { AmbientOcclusionGeometryProcessor } from './geometry-processor/ambient-occlusion-geometry';

export class AmbientOcclusionRenderer extends FeatureRenderer<AmbientOcclusionFeature> {
    modelToken = Token.AmbientOcclusionFeature;
    processor = new AmbientOcclusionGeometryProcessor(this.scene);

    updateMeshGeometry(
        feature: AmbientOcclusionFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>
    ) {
        const meshDynamicId = feature._parent?._dynamicId || '';

        return this.processor.updateMeshGeometry(feature, vertexData, vertexDataChanges, {
            meshDynamicId,
        });
    }

    update3dInternal() {}

    public delete3d(node: ITrackedClass<AmbientOcclusionFeature>, preserveCache?: boolean | undefined): void {
        this.viewer.updateFeatureWarnings(node, 0, true);
        super.delete3d(node);
    }
}
